module.exports = __webpack_public_path__ + "assets/img/code5.86e2b10a.png";